<template>
  <section aria-labelledby="error-card-id">
    <q-card
      bordered
      flat
      style="max-width:600px"
    >
      <q-card-section class="column items-center">
        <q-avatar
          color="primary"
          text-color="white"
          :icon="icon"
          size="100px"
        />
      </q-card-section>
      <q-card-section class="text-center">
        <h2
          id="error-card-id"
          class="text-primary q-ma-none fs-md"
        >{{ title }}</h2>
      </q-card-section>
      <q-card-section class="text-center">
        <slot name="text">
          <p>{{ text }}</p>
        </slot>
      </q-card-section>
      <q-card-section align="center">
        <slot name="actions">
          <q-btn
            v-for="action,i of actions"
            :key="i"
            unelevated
            class="wlk-btn"
            color="primary"
            v-bind="action"
          />
        </slot>
      </q-card-section>
    </q-card>
  </section>
</template>
<script>

export default {
  name: 'MeterReadingError',
  props: {
    icon: {
      type: String,
      default: () => 'app:cloud-attention'
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: () => null
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  setup () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
h2.fs-sm {
  font-size: var(--wlk-h2-fs-sm);
  font-family: "Open Sans 700", Arial, sans-serif !important;
}
</style>
